import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { AUDIT_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

interface mutateProps {
  jeMasterId: string;
  ujeAuditId: string;
  communityId: string;
  data: FieldValues
}
const mutateResubmitAuditForm = async ({ jeMasterId, ujeAuditId, communityId, data }: mutateProps) => {
  return await axiosAuth.post(`${AUDIT_API(communityId)}/${jeMasterId}/stage/${ujeAuditId}/resubmit`, data);
};

const useResubmitAuditFormMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateResubmitAuditForm,
    ...queryParams,
  });

export default useResubmitAuditFormMutation;
